module.exports = __webpack_public_path__ + "static/media/dbs.f7742b52.png";